import { render, staticRenderFns } from "./SocialReviewEmbed.vue?vue&type=template&id=7b983cda&scoped=true"
import script from "./SocialReviewEmbed.vue?vue&type=script&lang=js"
export * from "./SocialReviewEmbed.vue?vue&type=script&lang=js"
import style0 from "./SocialReviewEmbed.vue?vue&type=style&index=0&id=7b983cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b983cda",
  null
  
)

export default component.exports